import React from "react";

/**
 * Label over value, in the style of the Audit Logs `DefinitionList`: a small
 * uppercase secondary label and the value underneath. Used for every field in
 * the ticket detail side column so they all read the same (CTX-1121).
 */
export function DetailField({
  label,
  children,
}: {
  label: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="min-w-0">
      <dt className="text-xs font-semibold uppercase tracking-wide text-semantic-text-secondary">
        {label}
      </dt>
      <dd className="mt-1 text-sm text-semantic-text-primary break-words">
        {children}
      </dd>
    </div>
  );
}

/** Bordered card that groups fields in the side column. */
export function DetailCard({
  title,
  children,
  className = "",
}: {
  title?: string;
  children: React.ReactNode;
  /** Layout classes for where the card sits, e.g. to let it fill a column. */
  className?: string;
}) {
  return (
    <section
      className={`rounded-md border border-semantic-border-primary bg-semantic-bg-primary-alt p-4 ${className}`}
    >
      {title && (
        <h3 className="mb-3 text-xs font-semibold uppercase tracking-wide text-semantic-text-secondary">
          {title}
        </h3>
      )}
      {children}
    </section>
  );
}
